// extracted by mini-css-extract-plugin
export var menuIcon = "_ox-0";
export var menuIconInline = "_ox-1";